module.exports = __webpack_public_path__ + "assets/img/Record_tit.ab5b4bbe.png";